import type { BadgeVariant } from "components/ui/badge";

/**
 * Status chips for the announcement lists: a status-coloured hairline and a
 * wash of that colour, with ordinary text, in place of the shared Badge's flat
 * bright fills. The chip's own words ("Sent", "Failed") carry the meaning, so
 * colour is only a second signal. Passed as `className`, it replaces the
 * variant's fill and text colour.
 */
export function statusChipClass(variant: BadgeVariant): string {
  switch (variant) {
    case "success":
    case "default":
      return "border border-status-success bg-status-success/15 text-foreground";
    case "warning":
      return "border border-status-warning bg-status-warning/15 text-foreground";
    case "error":
      return "border border-status-error bg-status-error/15 text-foreground";
    case "info":
      return "border border-status-info bg-status-info/15 text-foreground";
    default:
      return "border border-border bg-muted text-foreground";
  }
}
